<template>
  <button type="button" @click.prevent="redirectToInvites()" class="btn btn-primary width--100per" :class="containerClass">
    <i class="fa fa-plus t-sm pr-2 t-white-darker"></i>{{ text }}
  </button>
</template>

<script>
export default {
  name: 'inviteButtonTeam',
  props: {
    researchGroup: {
      type: Object,
      required: false,
      default: () => {}
    },
    community: {
      type: Object,
      required: false,
      default: () => {}
    },
    text: {
      type: String,
      required: false,
      default: 'Add team member'
    },
    containerClass: {
      type: String,
      default: 'mb-3'
    }
  },
  methods: {
    redirectToInvites () {
      if (this.researchGroup) {
        if (this.$route.name !== 'research_group.invite') this.$router.push({ name: 'research_group.invite', params: { id: this.researchGroup.slug_values[0] } })
        this.$events.$emit('modal:invite:open:create', this.researchGroup, {})
      } else {
        if (this.$route.name !== 'community.invite') this.$router.push({ name: 'community.invite', params: { id: this.community.slug_values[0] } })
        this.$events.$emit('modal:invite:open:create', {}, this.community)
      }
    }
  }
}
</script>
